export enum GBError {
    ALREADY_LOGGED_IN = 'Already_logged_in',
    INVALID_SERVER_SETUP = 'Invalid_server_setup',
    LOGGING_OUT = 'Logging_out',
    INVALID_LOGIN_STATE = 'Invalid_login_state',
    INVALID_USER_ID = 'Invalid_user_ID',
    INVALID_AUTH_TOKEN = 'Invalid_auth_token',
    INVALID_CREDENTIALS = 'Invalid_credentials',
    USER_ID_GAME_ID_MISMATCH = 'User_ID_game_ID_mismatch',
    GAME_TIMEOUT = 'Game_Timed_Out',
    OTHER = 'Other',
}

export const GBErrorMap = {
    1590387213: GBError.INVALID_SERVER_SETUP,
    1654026616: GBError.ALREADY_LOGGED_IN,
    1590384515: GBError.ALREADY_LOGGED_IN,
    1590384521: GBError.LOGGING_OUT,
    1590384528: GBError.INVALID_LOGIN_STATE,
    1590387233: GBError.INVALID_USER_ID,
    1590387236: GBError.INVALID_AUTH_TOKEN,
    1590387246: GBError.INVALID_CREDENTIALS,
    1590384538: GBError.INVALID_CREDENTIALS,
    1599214196: GBError.USER_ID_GAME_ID_MISMATCH,
};
